// The `AGClubTastic` component takes `data` as a prop, extracts `dataSource` as `AGContent`,
// and passes it to the `AGClub` component. It renders the `AGClub` component with `agContent` as
// its prop, which is used to display the American Golf Club content. The component doesn't
// include any additional logic beyond passing the data and rendering `AGClub`.

'use client';

import AGClub from 'components/commercetools-ui/organisms/ag-club';
import React from 'react';
import { TasticProps } from '../types';
import { AGClubProps } from 'types/next';

const AGClubTastic = ({ data }: TasticProps<AGClubProps>) => {
  const AGContent = data?.data?.dataSource;

  return (
    <>
      <AGClub agContent={AGContent} />
    </>
  );
};

export default AGClubTastic;
